import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { NakedButton } from '@qga/roo-ui/components';
import { css } from '@emotion/core';

const StyledButton = styled(NakedButton)`
  padding: ${themeGet('space.2')} ${themeGet('space.4')};
  margin-right: ${themeGet('space.2')};
  border: ${themeGet('borders.2')};
  border-radius: ${themeGet('radii.rounded')};
  justify-content: center;
  white-space: nowrap;
  transition: background-color 0.2s ease-in-out;

  border-color: ${(props) => (props.selected ? themeGet('colors.brand.secondary')(props) : themeGet('colors.greys.alto')(props))};

  ${(props) =>
    props.selected &&
    css`
      background-color: ${themeGet('colors.ui.infoBackground')(props)};
    `};

  ${(props) =>
    props.disabled &&
    css`
      background-color: ${themeGet('colors.greys.alto')(props)};
    `};

  ${(props) =>
    !props.selected &&
    !props.disabled &&
    css`
      background-color: ${themeGet('colors.white')(props)};
    `};
  &:focus {
    outline: none;
    border-color: ${themeGet('colors.brand.secondary')};
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      outline: none;
      background-color: ${themeGet('colors.ui.infoBackground')};
      border-color: ${themeGet('colors.brand.secondary')};

      &:disabled {
        background-color: ${themeGet('colors.greys.alto')};
        border-color: ${themeGet('colors.greys.alto')};
      }
    }
  }
`;

const PillButton = ({ children, ...rest }) => <StyledButton {...rest}>{children}</StyledButton>;

PillButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PillButton;
